import {User, Calendar, MessageCircleCodeIcon} from 'lucide-react';
import {FullMessage} from "../api/ApiTypes.ts";
import {MetadataRow} from "./MetaDataRow.tsx";
import {formatDateTime} from "../utils/dateUtils.ts";

/**
 * MessageItem Component - Displays a single message with details
 */
export const MessageItem = ({ message }: { message: FullMessage }) => {


    // Skip hidden messages
    if (message.hide) {
        return null;
    }

    // Get sender name
    const senderName = [message.messageFromFirstName, message.messageFromLastName]
        .filter(Boolean)
        .join(' ');


    return (
        <div className="border border-slate-200 rounded-lg bg-white mb-4 shadow-sm overflow-hidden">
            <div className="p-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    {/* message info and type */}
                    <div className="flex-1">
                        <div className="flex items-start space-x-3">
                            <div className="p-2 bg-blue-50 rounded-md flex-shrink-0">
                                <MessageCircleCodeIcon className="h-6 w-6 text-blue-600" />
                            </div>
                            <div>
                                <h3 className="font-medium text-sm sm:text-base text-slate-800 break-all">
                                    {message.messageTypeDescription}
                                </h3>
                                {message.messageText && (
                                    <div className="text-sm text-slate-600 bg-slate-50 p-3 rounded-md">
                                        {message.messageText}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Action buttons */}
                    <div className="flex-shrink-0">

                    </div>
                </div>

                {/* File metadata */}
                <div className="mt-4 pt-3 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
                    <MetadataRow value={senderName} label='From: ' icon={<User className="h-4 w-4 mr-1 text-blue-700" />}></MetadataRow>
                    <MetadataRow value={formatDateTime(message.dateCreated)} label='Sent: ' icon={<Calendar className="h-4 w-4 mr-1 text-blue-700" />}></MetadataRow>
                </div>
            </div>
        </div>
    );
};